import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsAnalyticsDataViewListRoute: InvariantJiraRoute = {
	name: 'assets-analytics-data-view-list',
	path: '/jira/assets/analytics/data-view',
	exact: true,
};
